export function bigIntConverter(value: any) {
  return (value * 10 ** 18)
}

export function decimalConverter(value: any) {
  return value / 10 ** 18
}
